import { render, staticRenderFns } from "./PercentAndPeriodRateWidget.vue?vue&type=template&id=08b19f64&"
import script from "./PercentAndPeriodRateWidget.vue?vue&type=script&lang=js&"
export * from "./PercentAndPeriodRateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports